module.exports = __webpack_public_path__ + "img/tango_bot.32638de7.png";